export default __webpack_public_path__ + "static/media/13.c36decac.jpg";